import { createSlice } from "@reduxjs/toolkit";
import {
    getAchievementConfig,
    getAllAchievementConfigs,
    updateAchievementConfig,
} from "../Actions/AchievementActions";

interface AchievementState {
    professionalConfig: any | null;
    clientConfig: any | null;
    allConfigs: any[];
    loading: boolean;
    error: string | null;
}

const initialState: AchievementState = {
    professionalConfig: null,
    clientConfig: null,
    allConfigs: [],
    loading: false,
    error: null,
};

const achievementSlice = createSlice({
    name: "achievements",
    initialState,
    reducers: {
        clearAchievementError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // Get config
        builder
            .addCase(getAchievementConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAchievementConfig.fulfilled, (state, action) => {
                state.loading = false;
                const config = action.payload;
                if (config.configKey === "professional") {
                    state.professionalConfig = config;
                } else if (config.configKey === "client") {
                    state.clientConfig = config;
                }
            })
            .addCase(getAchievementConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });

        // Get all configs
        builder
            .addCase(getAllAchievementConfigs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAchievementConfigs.fulfilled, (state, action) => {
                state.loading = false;
                state.allConfigs = action.payload;
                
                // Also populate individual configs
                action.payload.forEach((config: any) => {
                    if (config.configKey === "professional") {
                        state.professionalConfig = config;
                    } else if (config.configKey === "client") {
                        state.clientConfig = config;
                    }
                });
            })
            .addCase(getAllAchievementConfigs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });

        // Update config
        builder
            .addCase(updateAchievementConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAchievementConfig.fulfilled, (state, action) => {
                state.loading = false;
                const config = action.payload;
                if (config.configKey === "professional") {
                    state.professionalConfig = config;
                } else if (config.configKey === "client") {
                    state.clientConfig = config;
                }
                
                // Update in allConfigs array
                const index = state.allConfigs.findIndex(c => c.configKey === config.configKey);
                if (index !== -1) {
                    state.allConfigs[index] = config;
                }
            })
            .addCase(updateAchievementConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearAchievementError } = achievementSlice.actions;
export default achievementSlice.reducer;

